"use client";

import { useCallback } from "react";
import { useMap } from "../context";
import {
  type FlyToBoundsOptions,
  flyToBounds,
  type LatLng,
} from "../utils/viewport";

/**
 * Returns a stable callback that smoothly animates the map to fit
 * a collection of coordinates. Must be used inside a MapProvider.
 *
 * @example
 * const flyTo = useFlyToBounds();
 * flyTo(items.map(i => ({ latitude: i.lat, longitude: i.lng })));
 */
export function useFlyToBounds() {
  const { map } = useMap();

  return useCallback(
    (points: LatLng[], options?: FlyToBoundsOptions) => {
      if (!map) {
        return;
      }
      flyToBounds(map, points, options);
    },
    [map]
  );
}
